// REF do imóvel: o código interno da Leilancer, como um código de produto.
//
// Sai do id do imóvel no banco, que nunca muda — então a REF de um imóvel é a
// mesma na busca, na página dele, no Gerenciador e no PDF que vai para o
// cliente, sem precisar gerar nem guardar nada. "LC-" deixa claro que é nosso
// e evita confundir com número de lote ou de processo.

export const refDoImovel = (id) => (id ? `LC-${id}` : '');

/** "LC-123456", "lc 123456" ou "LC123456" -> 123456; qualquer outra coisa -> null. */
export function idDaRef(texto) {
  const m = /^\s*(?:LC[\s-]*)?(\d{1,9})\s*$/i.exec(String(texto || ''));
  return m && Number(m[1]) > 0 ? Number(m[1]) : null;
}

